import {
	SET_AVAILABLE_ASSETS,
	SHOW_ERROR_MESSAGE,
	SHOW_SUCCESS_MESSAGE,
	HIDE_TOAST_MESSAGE,
} from "./FrequencyTrendLimitConfigurationActionsType";
import { RESET_STATE } from "@/stores/CommumActionTypes";
import {
	FREQUENCY_TREND_LIMIT_LOG_PATH,
	FREQUENCY_TREND_CONFIGURED_LIMITS_PATH,
	FREQUENCY_TREND_LIMIT_CONFIGURATOR_PATH
} from "./ModulePath";

const actions = {
	/**
   * Define os ativos disponíveis e guarda no state do modulo.
   *
   * @param {Object} context - O contexto Vuex.
   * @param {Array} assets - Lista de ativos disponíveis.
   */
	[SET_AVAILABLE_ASSETS]({ commit }, assets)
	{
		commit(SET_AVAILABLE_ASSETS, assets);
	},

	/**
   * Altera o state do toast message para exibir uma mensagem de erro.
   *
   * @param {Object} context - O contexto Vuex.
   * @param {string} message - Mensagem de erro a ser exibida.
   */
	[SHOW_ERROR_MESSAGE]({ commit }, message)
	{
		commit(SHOW_ERROR_MESSAGE, message);
	},

	/**
   * Altera o state do toast message para exibir uma mensagem de sucesso.
   *
   * @param {Object} context - O contexto Vuex.
   * @param {string} message - Mensagem de sucesso a ser exibida.
   */
	[SHOW_SUCCESS_MESSAGE]({ commit }, message)
	{
		commit(SHOW_SUCCESS_MESSAGE, message);
	},

	/**
   * Altera o state do toast message para esconder a mensagem no front.
   *
   * @param {Object} context - O contexto Vuex.
   */
	[HIDE_TOAST_MESSAGE]({ commit })
	{
		commit(HIDE_TOAST_MESSAGE);
	},

	/**
   * Reseta o state da store pai e seus filhos.
   *
   * @param {Object} context - O contexto Vuex.
   */
	[RESET_STATE]({ commit })
	{
		commit(RESET_STATE);
		commit(`${FREQUENCY_TREND_LIMIT_CONFIGURATOR_PATH}/${RESET_STATE}`, null, { root: true });
		commit(`${FREQUENCY_TREND_CONFIGURED_LIMITS_PATH}/${RESET_STATE}`, null, { root: true });
		commit(`${FREQUENCY_TREND_LIMIT_LOG_PATH}/${RESET_STATE}`, null, { root: true });
	}
};

export default { actions };